<template>
  <div class="d-flex align-center">
    <div>
      <v-btn
        class="py-1"
        small
        style="height: auto"
        @click="openSupplierSelect"
      >
        {{ supplierName }}
      </v-btn>
    </div>

    <SupplierSelectDialog
      ref="supplierSelectDialog"
      :suppliers="suppliers"
      :loading="loading"
    />
  </div>
</template>

<script>
import api from "../api";

export default {
  data: () => ({
    loading: false,
    suppliers: [],
  }), //data

  mounted() {
    this.loadSuppliersAsync();
  }, // mounted

  computed: {
    supplierSelectDialog() {
      return this.$refs.supplierSelectDialog;
    },
    supplierName() {
      if (this.loading) return "Loading...";

      const supplier = this.suppliers.find(
        (s) => s.internalId == this.supplierInternalId
      );

      if (!supplier) return "Select a Supplier";

      return supplier.supplierName;
    },
    supplierInternalId: {
      get() {
        return this.$store.state.supplierInternalId;
      },
      set(value) {
        this.$store.state.supplierInternalId = value;
      },
    },
  }, // computed

  methods: {
    async loadSuppliersAsync() {
      this.loading = true;

      try {
        this.suppliers = await api.suppliers.getFromCurrentUser();

        if (this.suppliers)
          this.supplierInternalId = this.suppliers[0].internalId;
      } finally {
        this.loading = false;
      }
    },
    async openSupplierSelect() {
      try {
        const supplier =
          await this.supplierSelectDialog.openAndGetSupplierAsync();
        this.$store.commit("setSupplierInternalId", supplier.internalId);
      } catch {
        /* eslint-disable */
      }
    },
  }, // methods
};
</script>
